<div class="card border-0 shadow mb-4 text-center text-sm-start"
     [ngClass]="{'card-visit-cancelled': visit.visitStatus === VisitStatusEnum.Cancelled }">
  <div class="card-body d-flex flex-column flex-sm-row justify-content-center justify-content-sm-start">
    <div class="text-center me-sm-5 mb-3 mb-sm-0">
      <span>
        <div class="d-flex d-sm-none align-items-center visit-status visit-status-pending justify-content-end"
             [ngClass]="{
           'visit-status-pending': visit.visitStatus === VisitStatusEnum.Pending,
           'visit-status-completed': visit.visitStatus === VisitStatusEnum.Completed,
           'visit-status-cancelled': visit.visitStatus === VisitStatusEnum.Cancelled
           }">
          <p class="status-dot me-2 mb-0"></p>
          <p class="status-name mb-0">
            {{ visitStatusTranslationKey | translate }}
          </p>
        </div>
      </span>
      <span class="d-none d-sm-inline">
        {{visit.visitDate | monthAbbrevKeyFromDate | translate}}
      </span>
      <br class="d-none d-sm-inline-block">
      <ng-container *ngIf="visitIsNotInThisYear">
        <span class="d-none d-sm-inline">
          {{visit.visitDate | date: 'y'}}
        </span>
        <br class="d-none d-sm-inline-block">
      </ng-container>
      <span class="month-day h2 m-0 fw-bold">
        {{visit.visitDate | date: 'd'}}
      </span>
      <span class="d-sm-none month-day text-nowrap h2 m-0 fw-bold">
        {{visit.visitDate | date:'MMMM' | titlecase | translate}}
      </span>
      <ng-container *ngIf="visitIsNotInThisYear">
        <span class="d-sm-none h2 m-0 fw-bold">
          {{visit.visitDate | date: 'y'}}
        </span>
      </ng-container>
      <br>
      <span class="fw-bold">
        {{visit.visitDate | date: 'HH:mm'}}
      </span>
    </div>
    <div class="flex-fill">
      <div class="d-flex justify-content-center justify-content-sm-between">
        <div class="h5 notranslate m-0">
          {{ visit.salonName }}
        </div>
        <div class="d-sm-flex d-none align-items-center visit-status visit-status-pending justify-content-center justify-content-sm-start"
             [ngClass]="{
           'visit-status-pending': visit.visitStatus === VisitStatusEnum.Pending,
           'visit-status-completed': visit.visitStatus === VisitStatusEnum.Completed,
           'visit-status-cancelled': visit.visitStatus === VisitStatusEnum.Cancelled
           }">
          <p class="status-dot me-2 mb-0"></p>
          <p class="status-name mb-0">
            {{ visitStatusTranslationKey | translate }}
          </p>
        </div>
      </div>
      <p class="small text-muted">{{visit | salonFormattedAddress}}</p>
      <p title="{{visit.treatments[0].treatmentName}}"
         class="treatment-name h2 mb-1 notranslate">{{ visit.treatments[0].treatmentName | truncate:[30, '...']
        }}</p>
      <p class="details-pill small text-muted">{{ visit.treatments[0].isEmployeeSelected ?
        visit.treatments[0].employeeName :
        'CUSTOMER-ACCOUNT.VISITS-VIEW.ANY-SPECIALIST' | translate }}</p>

      <div *ngIf="visit.showMore && (visit.treatments.length > 1 || visit.visitRemarks)"
           [@inOutAnimation]
           class="mb-3">
        <div *ngFor="let treatment of visit.treatments | slice:1; let i = index">
          <p title="{{treatment.treatmentName}}"
             class="treatment-name h5 ms-1 mb-0 notranslate">{{ treatment.treatmentName | truncate:[30, '...']
            }}</p>
          <p class="details-pill small text-muted">{{ treatment.isEmployeeSelected ? treatment.employeeName
            : 'CUSTOMER-ACCOUNT.VISITS-VIEW.ANY-SPECIALIST' | translate }}</p>
        </div>
        <span *ngIf="visit.visitRemarks"
              class="fst-italic text-muted">&#8222;{{ visit.visitRemarks }}&#8221;
        </span>
      </div>
      <div class="d-flex flex-column-reverse flex-sm-row-reverse justify-content-between align-items-center">
        <button *ngIf="visit.visitStatus === VisitStatusEnum.Pending"
                type="button"
                (click)="tryCancelVisit()"
                class="btn btn-outline-danger">
          {{ 'CUSTOMER-ACCOUNT.VISITS-VIEW.BUTTON-CANCEL-VISIT' | translate}}
        </button>
        <button type="button"
                (click)="goToSalonPage(); false"
                *ngIf="visit.visitStatus !== VisitStatusEnum.Pending"
                class="btn btn-primary">
          {{ 'CUSTOMER-ACCOUNT.VISITS-VIEW.BUTTON-SCHEDULE-VISIT' | translate}}
        </button>
        <a *ngIf="visit.treatments.length > 1 || visit.visitRemarks"
           href="#"
           (click)="toggleShowMore(); false"
           class="mb-3 mb-sm-0">
          <span *ngIf="visit.showMore">
            {{ 'CUSTOMER-ACCOUNT.VISITS-VIEW.BUTTON-SHOW-LESS' | translate}}
          </span>
          <span *ngIf="!visit.showMore">
            {{ 'CUSTOMER-ACCOUNT.VISITS-VIEW.BUTTON-SHOW-MORE' | translate}}
          </span>
        </a>
      </div>
    </div>
  </div>
</div>
